<template>
  <div>
    <LeftSide
      :status="leftSideStatus"
      :keyStatus="filterProps.status"
      :keyType="filterProps.type"
      :keyName="filterProps.name"
      :keyUrl="filterProps.url"
      @filtrate="filtrate"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :keyStatus="filterProps.status"
        :keyType="filterProps.type"
        :keyName="filterProps.name"
        :keyUrl="filterProps.url"
        @clearKey="clearKey"
        @shareAlbum="shareAlbum"
      />
      <router-view
        :first_loading="firstLoading"
        :items="items"
        @editProImg="editProImg"
        @removeLot="removeLot"
        @copyLot="copyLot"
        @moveLot="moveLot"
        :albumItem="albumItem"
        @openUpload="openUpload"
        @submitAudit="submitAudit"
      ></router-view>
      <pagination
        class="pd-x-20 pd-sm-x-30"
        :cur="page"
        :all="totalPage"
        :path="'/product-img-detail/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      ></pagination>
      <api-loading :show="loading"></api-loading>
    </div>
    <Modal
      :modalId="'modalEditProImg'"
      :home="false"
      :loading="modalEditProImg.loading"
      :size="'lg'"
      :autoH="false"
    >
      <template slot="header">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("product.编辑相册") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </template>
      <template slot="body">
        <div class="body-inner">
          <div class="form-group row align-items-center">
            <label
              class="
                col-md-2 col-sm-12 col-form-label
                form-control-sm
                text-right
              "
              >{{ $t("product.相册名称：") }}</label
            >
            <div class="col-md-9 col-sm-12">
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="modalEditProImg.name"
              />
            </div>
          </div>
          <div class="form-group row align-items-center">
            <label
              class="
                col-md-2 col-sm-12 col-form-label
                form-control-sm
                text-right
              "
              >{{ $t("product.相册类型：") }}</label
            >
            <div class="col-md-9 col-sm-12">
              {{ $t($dict.imgsType[modalEditProImg.type]) }}
            </div>
          </div>
          <div class="form-group row align-items-center">
            <label
              class="
                col-md-2 col-sm-12 col-form-label
                form-control-sm
                text-right
              "
              >{{ $t("product.相册权限：") }}</label
            >
            <div class="col-md-9 col-sm-12">
              <div
                class="form-check form-check-inline pd-r-15"
                v-for="(s, k) in $dict.imgsStatus"
                :key="k"
              >
                <label class="rdiobox">
                  <input
                    type="radio"
                    name="status"
                    :value="k"
                    v-model="modalEditProImg.status"
                  />
                  <span>{{ $t(s) }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="modal-footer d-block pd-y-15 pd-x-0">
          <div
            class="
              form-group
              row
              align-items-center
              justify-content-end
              pd-x-25
              mg-b-0
            "
          >
            <button
              type="button"
              class="
                mg-r-15
                btn btn-primary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              @click="saveAlbum"
            >
              {{ $t("product.保存") }}
            </button>
            <button
              type="button"
              class="
                btn btn-secondary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              data-dismiss="modal"
            >
              {{ $t("product.取消") }}
            </button>
          </div>
        </div>
      </template>
    </Modal>
    <Modal
      :modalId="'modalCopyProImg'"
      :home="false"
      :loading="modalCopyProImg.loading"
      :size="'lg'"
      :autoH="false"
    >
      <template slot="header">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("product.复制地址") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </template>
      <template slot="body">
        <div class="body-inner">
          <div class="">
            <div class="form-check form-check-inline pd-r-15">
              <label class="rdiobox">
                <input
                  type="radio"
                  name="type"
                  value="1"
                  v-model="modalCopyProImg.type"
                />
                <span>{{ $t("product.复制url地址") }}</span>
              </label>
            </div>
            <div class="form-check form-check-inline pd-r-15">
              <label class="rdiobox">
                <input
                  type="radio"
                  name="type"
                  value="2"
                  v-model="modalCopyProImg.type"
                />
                <span>{{ $t("product.复制html代码") }}</span>
              </label>
            </div>
          </div>
          <div class="type-wrap">
            <div v-if="modalCopyProImg.type == 1">
              <p
                class="mg-b-5"
                v-for="(item, i) in modalCopyProImg.items"
                :key="i"
              >
                {{ item.imgUrl }}
              </p>
            </div>
            <div v-if="modalCopyProImg.type == 2">
              <p
                class="mg-b-5"
                v-for="(item, i) in modalCopyProImg.items"
                :key="i"
                style="word-break: break-all"
              >
                &lt;img src="{{ item.imgUrl }}"/&gt;
              </p>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="modal-footer d-block pd-y-15 pd-x-0">
          <div
            class="
              form-group
              row
              align-items-center
              justify-content-end
              pd-x-25
              mg-b-0
            "
          >
            <button
              type="button"
              class="
                mg-r-15
                btn btn-primary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              id="copyInviteLink"
              :data-clipboard-text="modalCopyProImg.copyText"
            >
              {{ $t("product.复制") }}
            </button>
            <button
              type="button"
              class="
                btn btn-secondary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              data-dismiss="modal"
            >
              {{ $t("product.取消") }}
            </button>
          </div>
        </div>
      </template>
    </Modal>
    <Modal
      :modalId="'modalMoveProImg'"
      :home="false"
      :loading="modalMoveProImg.loading"
      :size="'md'"
      :autoH="false"
    >
      <template slot="header">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("product.移动照片") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </template>
      <template slot="body">
        <div class="body-inner" style="min-height: 100px">
          <div class="d-flex align-items-center justify-content-center">
            <span class="mg-r-10">{{ $t("product.将照片移动到") }}</span>
            <select
              class="form-control form-control-sm wd-300"
              v-model="modalMoveProImg.toAlbumId"
            >
              <option value="">{{ $t("product.选择一个相册") }}</option>
              <template v-for="(item, i) in modalMoveProImg.items">
                <option
                  :key="i"
                  v-if="item.id != modalMoveProImg.fromAlbumId"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </template>
            </select>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="modal-footer d-block pd-y-15 pd-x-0">
          <div
            class="
              form-group
              row
              align-items-center
              justify-content-end
              pd-x-25
              mg-b-0
            "
          >
            <button
              type="button"
              class="
                mg-r-15
                btn btn-primary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              @click="saveMove()"
            >
              {{ $t("product.保存") }}
            </button>
            <button
              type="button"
              class="
                btn btn-secondary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              data-dismiss="modal"
            >
              {{ $t("product.取消") }}
            </button>
          </div>
        </div>
      </template>
    </Modal>
    <Modal
      :modalId="'modalShareAlbum2'"
      :home="false"
      :loading="modalShareAlbum.loading"
      :size="'lg'"
      :autoH="false"
    >
      <template slot="header">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("product.设置分享相册信息") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </template>
      <template slot="body">
        <div class="body-inner">
          <div class="form-group row align-items-center mg-0 mg-b-15">
            <label class="col-form-label form-control-sm text-right wd-100">
              {{ $t("product.分享链接：") }}
            </label>
            <div
              class="col-md-9 col-sm-12 tx-gray-900 d-flex align-items-center"
            >
              <span>
                <a class="tx-info" :href="albumUrl" target="_blank">
                  {{ albumUrl }}
                </a>
                <a
                  class="to-clipboard mg-l-5"
                  href="javascript:;"
                  :data-clipboard-text="albumUrl"
                >
                  <i class="icon ion-clipboard"></i>
                </a>
              </span>
              <a
                style="white-space: nowrap"
                class="mg-l-30 tx-12 d-flex align-items-center tx-gray-900"
                href="javascript:;"
                data-toggle="tooltip"
                data-placement="bottom"
                :data-original-title="setShareImg"
                data-html="true"
              >
                {{ $t("product.扫一扫 手机看") }}
                <i class="fa fa-qrcode tx-14 mg-l-5"></i>
              </a>
            </div>
          </div>
          <div class="form-group row align-items-center mg-0 mg-b-15">
            <label class="col-form-label form-control-sm text-right wd-100">
              {{ $t("product.联系人") }}：
            </label>
            <div class="col-md-9 col-sm-12 tx-gray-900">
              <input
                type="text"
                v-model="modalShareAlbum.contact"
                class="form-control form-control-sm tx-13"
              />
            </div>
          </div>
          <div class="form-group row align-items-center mg-0 mg-b-15">
            <label class="col-form-label form-control-sm text-right wd-100">
              {{ $t("product.手 机") }}：
            </label>
            <div class="col-md-9 col-sm-12 tx-gray-900">
              <input
                type="text"
                v-model="modalShareAlbum.mobile"
                class="form-control form-control-sm tx-13"
              />
            </div>
          </div>
          <div class="form-group row align-items-center mg-0 mg-b-15">
            <label class="col-form-label form-control-sm text-right wd-100">
              Q&emsp;Q：
            </label>
            <div class="col-md-9 col-sm-12 tx-gray-900">
              <input
                type="text"
                v-model="modalShareAlbum.qq"
                class="form-control form-control-sm tx-13"
              />
            </div>
          </div>
          <div class="form-group row align-items-center mg-0 mg-b-15">
            <label class="col-form-label form-control-sm text-right wd-100">
              {{ $t("product.旺 旺") }}：
            </label>
            <div class="col-md-9 col-sm-12 tx-gray-900">
              <input
                type="text"
                v-model="modalShareAlbum.wangwang"
                class="form-control form-control-sm tx-13"
              />
            </div>
          </div>
          <div class="form-group row align-items-center mg-0 mg-b-5">
            <label class="col-form-label form-control-sm text-right wd-100">
              {{ $t("product.地 址") }}：
            </label>
            <div class="col-md-9 col-sm-12 tx-gray-900 d-flex">
              <div class="col pd-l-0">
                <select
                  class="form-control form-control-sm"
                  @change="selectProvince()"
                  v-model="modalShareAlbum.province"
                  name="addressProvince"
                >
                  <option
                    v-for="(province, index) in selectCityArr"
                    :key="index"
                    v-text="province.name"
                    :value="index"
                  ></option>
                </select>
              </div>
              <div class="col">
                <select
                  class="form-control form-control-sm"
                  @change="selectCity()"
                  v-model="modalShareAlbum.city"
                  :disabled="cityArr.length < 1"
                  name="addressCity"
                >
                  <option
                    v-for="(city, index) in cityArr"
                    :key="index"
                    v-text="city.name"
                    :value="index"
                  ></option>
                </select>
              </div>
              <div class="col pd-r-0">
                <select
                  class="form-control form-control-sm"
                  v-model="modalShareAlbum.area"
                  :disabled="areaArr.length < 1"
                  name="addressArea"
                >
                  <option
                    v-for="(area, index) in areaArr"
                    :key="index"
                    v-text="area.name"
                    :value="index"
                  ></option>
                </select>
              </div>
            </div>
          </div>
          <div class="form-group row align-items-center mg-0 mg-b-15">
            <label class="col-form-label form-control-sm text-right wd-100">
            </label>
            <div class="col-md-9 col-sm-12 tx-gray-900">
              <input
                v-model="modalShareAlbum.address"
                class="form-control form-control-sm tx-13"
                :placeholder="$t('product.地址')"
              />
            </div>
          </div>
          <div class="form-group row align-items-center mg-0 mg-b-15">
            <label class="col-form-label form-control-sm text-right wd-100">
              {{ $t("product.邮 编") }}：
            </label>
            <div class="col-md-9 col-sm-12 tx-gray-900">
              <input
                type="text"
                v-model="modalShareAlbum.postCode"
                class="form-control form-control-sm tx-13"
              />
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="modal-footer d-block pd-y-15 pd-x-0">
          <div
            class="
              form-group
              row
              align-items-center
              justify-content-end
              pd-x-25
              mg-b-0
            "
          >
            <button
              type="button"
              class="
                mg-r-15
                btn btn-primary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              @click="saveShare"
            >
              {{ $t("product.保存") }}
            </button>
            <button
              type="button"
              class="
                btn btn-secondary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              data-dismiss="modal"
            >
              {{ $t("product.取消") }}
            </button>
          </div>
        </div>
      </template>
    </Modal>
    <confirmComponent
      @del_index_i="deletesFn"
      :modal_id="delAddr.modalId"
      :modal_title="delAddr.title"
      :modal_text="delAddr.text"
      :del_index="delAddr.delIndex"
    ></confirmComponent>
    <ModalUploadPic
      :open="openUploadPic"
      :folder="uploadFolder"
      :num="uploadFolderNum"
      :type="type"
      @uploadSuccess="uploadSuccess"
    />
  </div>
</template>

<script>
import LeftSide from "./left-side.vue"; //$t('product.左边栏')
import Header from "./header.vue"; //$t('product.头')
import Modal from "@components/Modal";
import { pagination, innerPagination } from "@components/pagination.js"; //$t('product.分页')
import { confirmComponent } from "@components/components.js"; //$t('product.$t('product.删除')确认')
import ModalUploadPic from "@components/supplier/modal-upload-pic"; //$t('product.选图片文件上传图片')
export default {
  data() {
    return {
      leftSideStatus: store.get("leftSideStatus"), //$t('product.左边栏')状态
      firstLoading: true,
      loading: false,
      page: this.$route.params.page ? this.$route.params.page : 1,
      totalPage: 1,
      rowsPerPage: parseInt(store.get("product-img-detail-rowsPerPage"))
        ? parseInt(store.get("product-img-detail-rowsPerPage"))
        : 10,
      pageSizeSelect: [10, 20, 50],
      totalCount: 0,
      items: [],
      totalItems: [],
      totalData: [],
      filterProps: {
        status: "",
        type: "",
        clickType: "",
        name: "",
        url: "",
      },
      id: this.$route.query.id,
      modalEditProImg: {
        loading: false,
        name: "",
        type: "",
        status: "",
        mode: 1,
      },
      delAddr: {
        modalId: "modalDelProImg",
        title: this.$t("product.删除"),
        text: this.$t("product.确定要删除吗"),
        delIndex: "",
        ids: [],
      },
      modalCopyProImg: {
        loading: false,
        type: 1,
        items: [],
        copyText: "",
      },
      modalMoveProImg: {
        loading: false,
        items: [],
        ids: [],
        toAlbumId: "",
        fromAlbumId: this.$route.query.id,
      },
      albumItem: "",
      openUploadPic: Symbol(),
      uploadFolder: "",
      uploadFolderNum: "",
      modalShareAlbum: {
        loading: false,
        contact: "",
        mobile: "",
        qq: "",
        wangwang: "",
        province: 0,
        city: 0,
        area: "",
        address: "",
        postCode: "",
      },
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      selectCityArr: arrCity,
      cityArr: [],
      areaArr: [],
      configInfoCopy: "",
      configInfo: "",
      setShareImg: "",
      albumUrl: "",
      type: "",
    };
  },
  components: {
    ModalUploadPic,
    LeftSide,
    Header,
    Modal,
    pagination,
    confirmComponent,
    innerPagination,
  },
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("product-img-detail-rowsPerPage", this.rowsPerPage);
    },
    copyType: function () {
      this.modalCopyProImg.copyText = "";
      if (this.modalCopyProImg.type == 1) {
        this.modalCopyProImg.items.forEach((e) => {
          let img = e.imgUrl + "\n";
          this.modalCopyProImg.copyText += img;
        });
      } else {
        this.modalCopyProImg.items.forEach((e) => {
          this.modalCopyProImg.copyText += `<img src="${e.imgUrl}"/>\n`;
        });
      }
    },
  },
  mounted() {
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "transfer.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("transfer.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("transfer.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
        });
      }
    }
    this.getItems();
  },
  updated() {
    $('[data-toggle="tooltip"]').tooltip({
      template:
        '<div class="tooltip tooltip-primary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
    });
  },
  computed: {
    copyType() {
      return this.modalCopyProImg.type;
    },
  },
  methods: {
    submitAudit(item) {
      $('[data-toggle="tooltip"]').tooltip("hide"); //$t('product.关闭所有') tooltip
      this.loading = true;
      $.api_call(
        "api.SupplierAlbum.submitAudit",
        {
          albumId: item.albumId,
          id: item.id,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("product.申诉提交成功"), "success");
            this.$set(item, "auditStatus", 1);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    saveShare() {
      let params = {};
      if (
        !this.modalShareAlbum.contact &&
        !this.modalShareAlbum.mobile &&
        !this.modalShareAlbum.qq &&
        !this.modalShareAlbum.wangwang &&
        !this.modalShareAlbum.address &&
        !this.modalShareAlbum.province &&
        !this.modalShareAlbum.city &&
        !this.modalShareAlbum.area &&
        !this.modalShareAlbum.postCode
      ) {
        ShowTip(this.$t("product.请填写联系信息"), "danger");
        return;
      }
      params.contactJson = {
        contact: this.modalShareAlbum.contact,
        mobile: this.modalShareAlbum.mobile,
        QQ: this.modalShareAlbum.qq,
        wangwang: this.modalShareAlbum.wangwang,
        address: this.modalShareAlbum.address,
        postCode: this.modalShareAlbum.postCode,
        province: this.modalShareAlbum.province
          ? this.selectCityArr[this.modalShareAlbum.province].name
          : undefined, //$t('product.省份')
        provinceId: this.modalShareAlbum.province
          ? this.selectCityArr[this.modalShareAlbum.province].key
          : undefined,
        city: this.modalShareAlbum.city
          ? this.cityArr[this.modalShareAlbum.city].name
          : undefined, //$t('product.城市')
        area:
          this.modalShareAlbum.area || this.modalShareAlbum.area === 0
            ? this.areaArr[this.modalShareAlbum.area].name
            : undefined, //$t('product.区域')
      };
      params.id = this.configInfo.id ? this.configInfo.id : 0;
      this.modalShareAlbum.loading = true;
      $.api_call("api.SupplierMallConfig.addConfig", params, (r) => {
        this.modalShareAlbum.loading = false;
        if (r.ErrorCode == "9999") {
          ShowTip(this.$t("product.保存成功"), "success");
          $("#modalShareAlbum").modal("hide");
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    selectProvince() {
      this.modalShareAlbum.city = 0;
      this.modalShareAlbum.area = undefined;
      this.cityArr = [];
      this.areaArr = [];
      let p = this.modalShareAlbum.province;
      if (this.selectCityArr[p] && this.selectCityArr[p].sub) {
        this.cityArr = this.selectCityArr[p].sub;
      } else {
        this.cityArr = [];
      }
    },
    selectCity() {
      this.modalShareAlbum.area = undefined;
      let c = this.modalShareAlbum.city;
      if (!c) return;
      if (this.cityArr[c].sub) {
        this.areaArr = this.cityArr[c].sub;
      } else {
        this.areaArr = [];
      }
    },
    shareAlbum() {
      this.albumUrl = this.userInfo.albumUrl + "#/album-detail?id=" + this.id;
      console.log(this.albumUrl);
      $.api_call(
        "api.SupplierMall.getShareUrl",
        {
          url: this.albumUrl,
        },
        (r) => {
          if (r.ErrorCode == "9999") {
            this.setShareImg =
              '<img style="height:150px" class="lottery_icon" src="' +
              r.Data.Results.url +
              '"/>';
          }
        }
      );
      this.loading = true;
      $.api_call("api.SupplierMallConfig.getConfig", {}, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          this.configInfo = r.Data.Results;
          if (this.configInfo.contactJson) {
            this.modalShareAlbum.contact = this.configInfo.contactJson.contact
              ? this.configInfo.contactJson.contact
              : "";
            this.modalShareAlbum.mobile = this.configInfo.contactJson.mobile
              ? this.configInfo.contactJson.mobile
              : "";
            this.modalShareAlbum.qq = this.configInfo.contactJson.QQ
              ? this.configInfo.contactJson.QQ
              : "";
            this.modalShareAlbum.wangwang = this.configInfo.contactJson.wangwang
              ? this.configInfo.contactJson.wangwang
              : "";

            this.modalShareAlbum.address = this.configInfo.contactJson.address
              ? this.configInfo.contactJson.address
              : "";
            this.modalShareAlbum.postCode = this.configInfo.contactJson.postCode
              ? this.configInfo.contactJson.postCode
              : "";
            this.cityArr = [];
            this.areaArr = [];
            if (this.configInfo.contactJson.province) {
              //$t('product.选省')
              for (let i = 0; i < this.selectCityArr.length; i++) {
                if (
                  this.selectCityArr[i].name ==
                  this.configInfo.contactJson.province
                ) {
                  this.modalShareAlbum.province = i;
                  this.selectProvince();
                  break;
                }
              }
            } else {
              this.modalShareAlbum.province = 0;
            }

            if (this.configInfo.contactJson.city) {
              //$t('product.选市')
              for (let i = 0; i < this.cityArr.length; i++) {
                if (this.cityArr[i].name == this.configInfo.contactJson.city) {
                  this.modalShareAlbum.city = i;
                  if (i > 0) this.selectCity();
                  break;
                }
              }
            } else {
              this.modalShareAlbum.city = 0;
            }

            if (this.configInfo.contactJson.area) {
              //$t('product.选区')
              for (let i = 0; i < this.areaArr.length; i++) {
                if (this.areaArr[i].name == this.configInfo.contactJson.area) {
                  this.modalShareAlbum.area = i;
                  break;
                }
              }
            } else {
              this.modalShareAlbum.area = undefined;
            }
          }
          this.configInfoCopy = JSON.parse(JSON.stringify(this.configInfo));
          this.modalShareAlbum.loading = false;
          $("#modalShareAlbum2").modal("show");
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    uploadSuccess() {
      this.getItems();
    },
    openUpload() {
      this.openUploadPic = Symbol();
      $("#modalUploadPic").modal("show");
    },
    moveLot(data) {
      this.modalMoveProImg.loading = false;
      this.modalMoveProImg.ids = data;
      this.loading = true;
      $.api_call("api.SupplierAlbum.findBySupplier", {}, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          $("#modalMoveProImg").modal("show");
          this.modalMoveProImg.items = r.Data.Results.datas;
          $("html,body").scrollTop(0);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    saveMove() {
      if (!this.modalMoveProImg.toAlbumId) {
        ShowTip(this.$t("product.请先选择一个相册"), "danger");
        return;
      }
      this.modalMoveProImg.loading = true;
      $.api_call(
        "api.SupplierAlbum.moveToAlbum",
        {
          fromAlbumId: this.modalMoveProImg.fromAlbumId,
          toAlbumId: this.modalMoveProImg.toAlbumId,
          ids: this.modalMoveProImg.ids,
        },
        (r) => {
          this.modalMoveProImg.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("product.移动成功"), "success");
            $("#modalMoveProImg").modal("hide");
            this.getItems();
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    copyLot(data) {
      this.modalCopyProImg.loading = false;
      this.modalCopyProImg.items = [];
      this.modalCopyProImg.type == 1;
      this.modalCopyProImg.copyText = "";
      data.forEach((e) => {
        this.items.forEach((s) => {
          if (e == s.id) {
            this.modalCopyProImg.items.push(s);
          }
        });
      });
      if (this.modalCopyProImg.type == 1) {
        this.modalCopyProImg.items.forEach((e) => {
          this.modalCopyProImg.copyText += e.imgUrl + "\n";
        });
      } else {
        this.modalCopyProImg.items.forEach((e) => {
          this.modalCopyProImg.copyText += `<img src="${e.imgUrl}"/>\n`;
        });
      }
      $("#modalCopyProImg").modal("show");
    },
    deletesFn() {
      this.loading = true;
      $.api_call(
        "api.SupplierAlbum.deleteImgBySupplier",
        {
          albumId: this.id,
          ids: this.delAddr.ids,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.getItems();
            $(`#${this.delAddr.modalId}`).modal("hide");
            ShowTip(this.$t("product.删除成功"), "success");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    removeLot(data) {
      this.delAddr.ids = data;
      $("#" + this.delAddr.modalId).modal("show");
    },
    editProImg() {
      this.modalEditProImg.loading = false;
      this.modalEditProImg.name = this.albumItem.name;
      this.modalEditProImg.type = this.albumItem.type;
      this.modalEditProImg.status = this.albumItem.status;
      $("#modalEditProImg").modal("show");
    },
    saveAlbum() {
      if (!this.modalEditProImg.name) {
        ShowTip(this.$t("product.请填写相册名称"), "danger");
        return;
      }
      this.modalEditProImg.loading = true;
      $.api_call(
        "api.SupplierAlbum.changeBySupplier",
        {
          id: this.id,
          type: this.modalEditProImg.type,
          name: this.modalEditProImg.name,
          status: this.modalEditProImg.status,
        },
        (r) => {
          this.modalEditProImg.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("product.修改成功"), "success");
            $("#modalEditProImg").modal("hide");
            this.getItems();
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    updateItems(id) {
      this.loading = true;
      $.api_call(
        "api.SupplierMallHelp.findBySupplier",
        {
          id: id,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            if (r.Data.Results.length == 0) return;
            this.items.forEach((e, i) => {
              if (e.id == r.Data.Results[0].id) {
                this.items.splice(i, 1, r.Data.Results[0]);
              }
            });
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    getItems() {
      this.loading = true;
      let params = {
        albumId: this.id,
      };
      $.api_call("api.SupplierAlbum.findImgsBySupplier", params, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          this.firstLoading = false;
          this.totalPage =
            Math.ceil(r.Data.Results.length / this.rowsPerPage) || 1;
          this.totalCount = r.Data.Results.length;
          for (let i = 0; i < this.totalPage; i++) {
            this.totalItems[i] = r.Data.Results.slice(
              this.rowsPerPage * i,
              this.rowsPerPage * (i + 1)
            );
          }
          this.items = this.totalItems[this.page - 1];
          this.totalData = r.Data.Results;
          this.uploadFolderNum = r.Data.Results.length;
          //        this.totalPage = r.Data.Pagination.totalPage;
          //        this.totalCount = r.Data.Pagination.totalCount;
          $("html,body").scrollTop(0);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });

      $.api_call("api.SupplierAlbum.findBySupplier", { id: this.id }, (r) => {
        if (r.ErrorCode == "9999") {
          this.albumItem = r.Data.Results.datas[0];
          //					console.log(r)
          this.uploadFolder = r.Data.Results.datas[0].name;
          this.type = r.Data.Results.datas[0].type;
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    getItemsBypage() {
      this.items = this.totalItems[this.page - 1];
    },
    clearKey(type) {
      this.filterProps[type] = "";
      //    this.toPage(1);
      this.page = 1;
      this.$router.push({ path: "/product-img-detail/" + this.page });
      this.getItems();
    },
    filtrate(status, type, name, url) {
      this.filterProps = {
        status,
        type,
        name,
        url,
      };
      //      this.toPage(1);
      let data = [];
      this.totalData.forEach((e) => {
        if (name && url) {
          if (e.name.indexOf(name) != -1 && e.imgUrl == url) {
            data.push(e);
          }
        } else {
          if (name) {
            if (e.name.indexOf(name) != -1) {
              data.push(e);
            }
          } else {
            if (e.imgUrl == url) {
              data.push(e);
            }
          }
        }
      });
      this.page = 1;
      this.totalPage = Math.ceil(data.length / this.rowsPerPage) || 1;
      this.totalCount = data.length;
      for (let i = 0; i < this.totalPage; i++) {
        this.totalItems[i] = data.slice(
          this.rowsPerPage * i,
          this.rowsPerPage * (i + 1)
        );
      }
      this.items = this.totalItems[this.page - 1];
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.push({ path: "/product-img-detail/" + 1 });
      this.totalPage = Math.ceil(this.totalData.length / this.rowsPerPage) || 1;
      this.totalCount = this.totalData.length;
      for (let i = 0; i < this.totalPage; i++) {
        this.totalItems[i] = this.totalData.slice(
          this.rowsPerPage * i,
          this.rowsPerPage * (i + 1)
        );
      }
      this.items = this.totalItems[this.page - 1];
    },
    toPage(num) {
      let page = this.page;
      this.$router.push({ path: "/product-img-detail/" + num });
      if (page == num) {
        this.getItemsBypage();
      }
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getItemsBypage();
    },
  },
};
</script>

<style lang="less" scoped>
.body-inner {
  [data-id="datepicker-from"],
  [data-id="datepicker-to"] {
    background-color: #fff;
    border-color: rgba(0, 0, 0, 0.15);
    color: #495057;
  }
  ul {
    padding: 0;
    list-style: none;
    margin-bottom: 0;
  }
}
.nav.nav-outline {
  padding: 0 15px;
}
.watermark {
  background: url(/img/9901973926.jpg) no-repeat 0 0;
  background-size: cover;
}
.mark_wrap.class-a {
  bottom: 0;
  right: 0;
}
.mark_wrap.class-b {
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.mark_wrap.class-c {
  bottom: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.type-wrap {
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #ddd;
  padding: 10px;
  margin-top: 10px;
}
</style>